/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Fixed_Weekdays_3Inputs */

const en_us2_onboarding_fixed_weekdays_3 = /** @type {(inputs: Onboarding_Fixed_Weekdays_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wednesday`)
};

const pt_br2_onboarding_fixed_weekdays_3 = /** @type {(inputs: Onboarding_Fixed_Weekdays_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarta`)
};

const es_419_onboarding_fixed_weekdays_3 = /** @type {(inputs: Onboarding_Fixed_Weekdays_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miércoles`)
};

const pt_pt2_onboarding_fixed_weekdays_3 = /** @type {(inputs: Onboarding_Fixed_Weekdays_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarta`)
};

const fr_fr2_onboarding_fixed_weekdays_3 = /** @type {(inputs: Onboarding_Fixed_Weekdays_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mercredi`)
};

const de_de2_onboarding_fixed_weekdays_3 = /** @type {(inputs: Onboarding_Fixed_Weekdays_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittwoch`)
};

const it_it2_onboarding_fixed_weekdays_3 = /** @type {(inputs: Onboarding_Fixed_Weekdays_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mercoledì`)
};

/**
* | output |
* | --- |
* | "Wednesday" |
*
* @param {Onboarding_Fixed_Weekdays_3Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_fixed_weekdays_3 = /** @type {((inputs?: Onboarding_Fixed_Weekdays_3Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Fixed_Weekdays_3Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_fixed_weekdays_3(inputs)
	if (locale === "es-419") return es_419_onboarding_fixed_weekdays_3(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_fixed_weekdays_3(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_fixed_weekdays_3(inputs)
	if (locale === "de-DE") return de_de2_onboarding_fixed_weekdays_3(inputs)
	if (locale === "it-IT") return it_it2_onboarding_fixed_weekdays_3(inputs)
	return en_us2_onboarding_fixed_weekdays_3(inputs)
});
export { onboarding_fixed_weekdays_3 as "onboarding.fixed_weekdays.3" }